import { useState } from "react";
import { useIntl } from "react-intl";
import Button from "../ui/button";
import QrScanner from "./QrScanner";

type BtnScannerProps = {
  onNewScan: (value: string) => void;
}

const BtnScanner = ({onNewScan}: BtnScannerProps) => {
  const intl = useIntl();
  const [displayModal, toggleModal] = useState(false);


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function onClickOverlay(e: any) {
    if (e.target.dataset?.overlay) {
      toggleModal(false);
    }
  }

  return (
    <>
      <Button onClick={() => toggleModal(true)} className="px-4" theme="black" size="medium" width="fit">
        {intl.formatMessage({ id: 'forms.objectCode.scanQr' })}
      </Button>
      {/* Overlay */}
      { displayModal ? (
        <div data-overlay className="fixed top-0 left-0 w-dvw h-dvh bg-black/75 grid place-items-center"
          onClick={onClickOverlay}>
          {/* Modal */}
          <div className="py-7 px-6 w-fit bg-white shadow-md rounded-lg">
            <h3 className="mb-5 font-bold text-center">
              {intl.formatMessage({ id: 'forms.objectCode.scanModalTitle' })}
            </h3>
            {/* Scanner container */}
            <div className="w-96">
              <QrScanner
                verbose={false}
                qrCodeSuccessCallback={(value) => {onNewScan(value); toggleModal(false)}} 
                config={{fps: 10, qrbox: 250, disableFlip: true}}
              />
            </div>
          </div>
        </div> ) : <></>
      }
    </>
  )
}

export default BtnScanner;
